// "≈ 1 700 km by road from Brisbane GPO" with the straight line beneath —
// one line for the bid and project site cards (28 Sep 2026, see lib/geo.ts).
import { useRoadKm, fmtKm } from "@/lib/geo";

export function DistanceFromBne({ site, canSave, className = "" }: { site: any; canSave: boolean; className?: string }) {
  const { roadKm, checking, straightKm } = useRoadKm(site, canSave);
  if (straightKm == null) return null;
  return (
    <span className={`inline-flex flex-col leading-tight ${className}`}>
      {roadKm != null
        ? <span>≈ {fmtKm(roadKm)} <span className="opacity-70">by road from Brisbane GPO</span></span>
        : <span>{fmtKm(straightKm)} <span className="opacity-70">straight line from Brisbane GPO{checking ? " · checking road…" : ""}</span></span>}
      {roadKm != null && <span className="opacity-60">{fmtKm(straightKm)} straight line</span>}
    </span>
  );
}
